import { useState } from 'react'
import type { Address } from 'viem'
import { Button } from '../common/button'
import { Dialog, DialogBody, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from '../common/dialog'
import { AddressForm } from './addressForm'

interface EditTrackableAddressDialogProps {
  className?: string
  address: Address | undefined
}

export const EditTrackableAddressDialog = ({ className, address }: EditTrackableAddressDialogProps) => {
  const [open, setOpen] = useState(false)

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <Button variant="secondary" size="sm" className={className}>
          Edit wallet address
        </Button>
      </DialogTrigger>
      <DialogContent position="center" className="max-w-[min(28rem,calc(100%-2rem))] md:max-w-xl">
        <DialogBody>
          <div className="flex flex-col gap-4 p-5 pt-8 md:p-8 md:pt-16">
            <DialogHeader>
              <DialogTitle>Edit wallet address</DialogTitle>
            </DialogHeader>
            <p>Enter the address or ENS of a wallet or connect a wallet to see the details of its performance.</p>
            <AddressForm address={address} onSubmitAction={() => setOpen(false)} />
          </div>
        </DialogBody>
      </DialogContent>
    </Dialog>
  )
}
